<template>
  <div id="app">
  
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 监听浏览器历史记录变化，防止用户通过返回按钮回到登录页面
    window.addEventListener('popstate', this.handlePopState);
    // 检查token是否过期
    this.checkTokenExpiration();
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    handlePopState() {
      const token = localStorage.getItem('token');
      // 如果用户已登录且当前路由是登录页，则重定向到首页
      if (token && this.$route.name === 'Login') {
        this.$router.push('/');
      }
    },
    checkTokenExpiration() {
      const token = localStorage.getItem('token');
      const expiration = localStorage.getItem('tokenExpiration');
      
      if (token && expiration) {
        // 检查token是否过期
        const now = new Date().getTime();
        if (now >= parseInt(expiration)) {
          // token已过期，清除本地存储并跳转到登录页
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('tokenExpiration');
          
          if (this.$route.name !== 'Login') {
            this.$router.push('/login');
          }
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100%;
}

/* 重置一些基本样式 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

/* 确保ElementUI组件正常显示 */
.el-button, .el-input, .el-select, .el-dialog, .el-form, .el-form-item, .el-pagination {
  display: inline-block !important;
}

/* 确保图标正常显示 */
.el-icon-search, .el-icon-delete, .el-icon-plus {
  display: inline-block !important;
  font-family: element-icons !important;
}
</style>
